import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchLots(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('reservation/lots', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteLot(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`reservation/lots/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
